import React from "react";
import PropTypes from "prop-types";
// Material imports
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { LogoLandingContainer } from "./..";
import { useAppConfig } from "@limitless/common/hooks";
const useStyles = makeStyles(theme => ({
  contentContainer: {
    position: "absolute",
    left: "2%",
    top: "27%",
    overflowY: "auto",
    width: "100%",
    height: "auto",
    maxHeight: "calc(100vh - 325px)"
  },
  [theme.breakpoints.up("sm")]: {
    contentContainer: {
      top: "20%",
      left: "12%",
      width: "88%",
      maxHeight: "calc(100vh - 220px)"
    }
  },
  [theme.breakpoints.up("md")]: {
    contentContainer: {
      top: "15%",
      left: "25%",
      width: "75%",
      maxHeight: "calc(100vh - 85px)"
    }
  },
  [theme.breakpoints.up("lg")]: {
    contentContainer: {
      top: "14%",
      left: "28%",
      width: "75%",
      maxHeight: "calc(100vh - 95px)"
    }
  }
}));
const EXTRA_INFO = {
  category: {
    Topic: "Webform"
  }
};
const ContactUsScreen = () => {
  const classes = useStyles();
  const {
    getExpertSupportDetails
  } = useAppConfig();
  const {
    publicSupport: {
      apiKey,
      tenantName,
      groupName
    },
    llmLandingPageUrl
  } = getExpertSupportDetails();
  React.useEffect(() => {
    const llmScoutNode = document.createElement("script");
    llmScoutNode.setAttribute("type", "text/javascript");
    llmScoutNode.setAttribute("src", llmLandingPageUrl);
    const bodyNodes = document.getElementsByTagName("body");
    const bodyNode = bodyNodes[bodyNodes.length - 1];
    bodyNode.appendChild(llmScoutNode);

    // Remove live-messenger script element on unmount
    return () => {
      document.body.removeChild(llmScoutNode);
    };
  }, []);
  return /*#__PURE__*/React.createElement(LogoLandingContainer, null, /*#__PURE__*/React.createElement(Grid, {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    id: "limitless-landing-root",
    "data-client-key": apiKey,
    "data-tenant-name": tenantName,
    "data-group-name": groupName,
    "data-locale": "en-GB"
  }), /*#__PURE__*/React.createElement("div", {
    id: "limitless-root",
    "data-app-visible": "always",
    "data-persistence": "false",
    "data-min-question-char-count": 10,
    "data-extra-info": JSON.stringify(EXTRA_INFO),
    "data-new-conversation-mode": "group-new-tab",
    "data-how-it-works": "disabled"
  })));
};
export default ContactUsScreen;
ContactUsScreen.propTypes = {
  classes: PropTypes.object
};